export const getDateFullYear = (date) => {
	const year = new Date(date).getFullYear()

	return year
}



// WEBPACK FOOTER //
// ./src/common/contentful/lib/getDateFullYear.js